// The order the review deck shows pending questions in.
//
// Oldest first, except anything the person just reframed or edited. Those are
// still pending (they need a fresh look before they can play), but showing the
// same card straight back reads as "the button did nothing", so they go to the
// back of the pile in the order they were sent there.

export function reviewOrder<T extends { id: string }>(pending: T[], sentBack: string[]): T[] {
  const back = new Map(sentBack.map((id, i) => [id, i]));
  const front = pending.filter((p) => !back.has(p.id));
  const rear = pending
    .filter((p) => back.has(p.id))
    .sort((a, b) => back.get(a.id)! - back.get(b.id)!);
  return [...front, ...rear];
}

// Send a card to the back. Moving it again moves it again: the latest action
// decides its place, so a card reframed twice ends up last, not stuck in the
// middle where it was first sent.
export function sendToBack(sentBack: string[], id: string): string[] {
  return [...sentBack.filter((x) => x !== id), id];
}

export function progressLabel(left: number): string {
  return left === 1 ? "Last one" : `${left} left`;
}
